import { PropertyKeyAvailableType } from '@acp/shared';
import { Text, VStack } from '@chakra-ui/react';
import { format } from 'date-fns';

export function KeyOnsiteAvailabilityText({
    onsiteAvailability,
    availableUntil,
    notes,
}: {
    onsiteAvailability: PropertyKeyAvailableType;
    availableUntil: Date | null;
    notes: string | null;
}) {
    if (onsiteAvailability === undefined) return null;

    if (onsiteAvailability === PropertyKeyAvailableType.Unavailable) {
        return (
            <Text>Key unavailable</Text>
        );
    }

    return (
        <VStack align="left" gap={6}>
            <Text>A key is available to collect at the property</Text>

            {
                onsiteAvailability === PropertyKeyAvailableType.Temporary
                    && availableUntil !== null
                    && (
                        <VStack align="left">
                            <Text fontWeight="medium">Available until</Text>
                            <Text>{format(availableUntil, 'dd/MM/yyyy')}</Text>
                        </VStack>
                    )
            }

            {
                notes !== null && (
                    <VStack align="left">
                        <Text fontWeight="medium">Key onsite notes</Text>
                        <Text>{notes}</Text>
                    </VStack>
                )
            }
        </VStack>
    );
}
